const Shipping = ({ ...props }) => {
  return (
    <svg
    width={18}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.775 10.4H17.1V7.36c0-.473-.191-.937-.529-1.272l-2.36-2.36a1.792 1.792 0 0 0-1.27-.528H11.7V1.81c0-.722-.624-1.31-1.39-1.31H1.39C.623.5 0 1.088 0 1.81v8.18c0 .722.624 1.31 1.39 1.31h.455a2.25 2.25 0 1 0 4.41 0h5.49a2.25 2.25 0 1 0 4.41 0h1.62a.226.226 0 0 0 .225-.225v-.45a.226.226 0 0 0-.225-.225ZM12.94 4.1c.237 0 .47.096.636.264l2.36 2.36c.022.023.03.053.05.079H11.7v-2.7h1.24V4.1Zm-8.89 9a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Zm1.789-2.7a2.242 2.242 0 0 0-1.789-.9c-.731 0-1.378.357-1.789.9H1.39c-.27 0-.489-.183-.489-.41V1.81c0-.227.22-.41.49-.41h8.92c.27 0 .49.183.49.41v8.59H5.839Zm8.111 2.7a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7Zm0-3.6c-.734 0-1.378.357-1.789.9H11.7V7.7h4.5v2.7h-.461a2.238 2.238 0 0 0-1.789-.9Z"
      fill="#464544"
    />
  </svg>
  )
}

export default Shipping
